<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">

  <app-lfsa-card-v2 *ngIf="mostrarView"
                    [innTemplateButton]="innTemplateButtonPedidos"
                    [innTemplate]="enviarTemplatePedidos" [modulo]="'IO-industrias'" [tituloCard]="titulo"
                    [titulo]="'Detalle'">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonPedidos>
  </ng-template>
  <ng-template #enviarTemplatePedidos>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [loading]="loading"
                                 [mostrarBotonVerde]="false">
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-loading-v2 *ngIf="loading2"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReadyPedidos($event)" [columnDefs]="columnDefsPedidos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsPedidos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                         [pagination]="true" [rowData]="rowDataPedidos"
                         [rowSelection]="rowSelectionPedidos" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idPedidos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaExtractos'"
                    [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formularioExtractos" class="form-group" novalidate>
      <div class="row">
        <div class="col-md-12 mb-4">
          <div class="form-group col-md-2">
            <app-lfsa-combo-box (change)="getExtractos(rowSelected)" [comboBox]="cmbEan14"
                                [control]="this.formularioExtractos.get('idBanco') | formControl" [idOpcion]="'idBanco'"
                                [id]="'idBanco'"
                                [label]="'Banco'" [opcion]="'dscaBanco'"
                                formControlName="idBanco"></app-lfsa-combo-box>
          </div>
        </div>
      </div>
    </form>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [formularioValido]="validateForm()"
                                 [loading]="loading"
                                 [textBoton]="textBoton"
    >
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <!--        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>-->
        <ag-grid-angular #agGrid (gridReady)="onGridReadyExtractos($event)" [columnDefs]="columnDefsExtractos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsExtractos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion" [pagination]="true"
                         [rowData]="rowDataExtractos"
                         [rowSelection]="rowSelectionExtractos"
                         [suppressRowClickSelection]="true" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idExtractos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="!mostrarView"
                    [innTemplate]="enviarTemplate" [modulo]="'IO-industrias'" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row mb-4">
          <div class="form-group col-md-4">
            <app-lfsa-input [control]="formulario.get('lote') | formControl"
                            [id]="'lote'"
                            [label]="'Lote'" [mostrarImg]="false" [placeholder]="'Lote'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="lote">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-4">
            <app-lfsa-input [control]="formulario.get('idMaterial') | formControl"
                            [id]="'idMaterial'"
                            [label]="'Material'" [mostrarImg]="false" [placeholder]="'Material'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="idMaterial">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-4">
            <br>
            <button (click)="findPerformReporte()"
            [disabled]="formulario.invalid"
            class="{{DAT_BTNCSS.primary}}">{{ DAT_BTNS.buscar }}
            </button>
          </div>
        </div>

      </form>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <div *ngIf="mostrarTabla" class="row">
        <div class="col-md-12 ">
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                           id="{{diccionarioModulo.agGrid.id}}">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
